import { render, staticRenderFns } from "./trend-down.vue?vue&type=template&id=405a48e4&scoped=true&"
import script from "./trend-down.vue?vue&type=script&lang=js&"
export * from "./trend-down.vue?vue&type=script&lang=js&"
import style0 from "./trend-down.vue?vue&type=style&index=0&id=405a48e4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "405a48e4",
  null
  
)

export default component.exports